<template>
  <div>
    <div class="row justify-left full-width q-py-none">
      <div class="row justify-left q-py-none q-my-none no-wrap">
        <q-input ref="dayField" class="thin-input-noborder" borderless 
          debounce="500" no-error-icon :input-style="`min-width: 15px; max-width: 15px;`"
          v-model="dayModel" :placeholder="$t('dd')"

          @keydown.left="focusPrev($event, 'day')" @keydown.backspace="focusPrev($event, 'day')" 
          @keydown.right="focusNext($event, 'day')" @keydown.esc="blurCurent()"
        />
        <div style="margin-top: 3px;">.&nbsp;</div>
        <q-input ref="monthField" class="thin-input-noborder" borderless 
          debounce="500" no-error-icon :input-style="`min-width: 15px; max-width: 15px;`"
          v-model="monthModel" :placeholder="$t('mm')"

          @keydown.left="focusPrev($event, 'month')" @keydown.backspace="focusPrev($event, 'month')" 
          @keydown.right="focusNext($event, 'month')" @keydown.esc="blurCurent()"
        />
        <div style="margin-top: 3px;">.&nbsp;</div>
        <q-input ref="yearField" class="thin-input-noborder" borderless 
          debounce="500" no-error-icon :input-style="`min-width: 40px; max-width: 40px;`"
          v-model="yearModel" :placeholder="$t('yyyy')"

          @keydown.left="focusPrev($event, 'year')" @keydown.backspace="focusPrev($event, 'year')" 
          @keydown.right="focusNext($event, 'year')" @keydown.esc="blurCurent()"
        />
      </div>
      <q-btn
        v-show="showClear"
        class="q-my-none q-pa-none unset-items-center"
        style="margin-top: -2px;"
        flat
        dense
        color="grey-7"
        icon="arrow_back"
        size="11px"
        @click.stop.prevent="clearDateModel"
      />
    </div>
    
  </div>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue, Watch } from 'vue-facing-decorator';
import { mdiSquareEditOutline, mdiCheckCircleOutline } from '@quasar/extras/mdi-v7'

@Component({
  name: 'DateTimeSelector',
  components: { }
})
export default class DateTimeSelector extends Vue {
    @Prop({ default: undefined })
    modelValue!: Date
    @Prop({ default: false })
    showClear!: boolean
    @Emit("update:modelValue") emitModelValue(arg: Date) { return arg; }

    squareEditIcon = mdiSquareEditOutline
    checkIcon = mdiCheckCircleOutline

    dayModel: string = ''
    monthModel: string = ''
    yearModel: string = ''

    created() {
      
    }

    get theModel() {
      return this.modelValue
    }

    clearDateModel() {
      this.dayModel = ''
      this.monthModel = ''
      this.yearModel = ''
    }

    blurCurent() {
      // @ts-ignore
      this.$refs.dayField.blur();
      // @ts-ignore
      this.$refs.monthField.blur();
      // @ts-ignore
      this.$refs.yearField.blur();
    }

    focusPrev(event: KeyboardEvent, level: string) {
      const prevLevel = (level == 'day' ? '' : (level == 'month' ? 'day' : 'year'))
      let modelValueLength = 0;
      switch (level) {
        case 'day':
          modelValueLength = this.dayModel.length;
          return;
        case 'month':
          modelValueLength = this.monthModel.length;
          return;
        case 'year':
          modelValueLength = this.yearModel.length;
          break;
        default:
          break;
      }
      const field: any = this.$refs[level+'Field'];

      if ((field && modelValueLength && (field.nativeEl.selectionStart <= 0 && field.nativeEl.selectionEnd === 0)) || 
        !modelValueLength) {
        this.focusInput(prevLevel)
        event.preventDefault();
      }
    }

    focusNext(event: KeyboardEvent, level: string) {
      const nextLevel = (level == 'day' ? 'month' : (level == 'month' ? 'year' : ''));
      let modelValueLength = 0;
      switch (level) {
        case 'day':
          modelValueLength = this.dayModel.length;
          return;
        case 'month':
          modelValueLength = this.monthModel.length;
          return;
        case 'year':
          modelValueLength = this.yearModel.length;
          break;
        default:
          break;
      }
      const field: any = this.$refs[level+'Field'];

      if ((field && modelValueLength && !field.nativeEl.selectionLength && 
      field.nativeEl.selectionStart >= modelValueLength) || !modelValueLength) {
        this.focusInput(nextLevel, true)
        event.preventDefault();
      }
    }

    focusInput(level: string, pos_start = false) {
      const field: any = this.$refs[level+'Field'];
      let modelValueLength = 0;
      switch (level) {
        case 'day':
          modelValueLength = this.dayModel.length;
          return;
        case 'month':
          modelValueLength = this.monthModel.length;
          return;
        case 'year':
          modelValueLength = this.yearModel.length;
          break;
        default:
          break;
      }

      if (field) {
        field.focus();
        if (pos_start) {
          field.nativeEl.selectionStart = 0;
          field.nativeEl.selectionEnd = 0;
        } else {
          field.nativeEl.selectionStart = modelValueLength;
          field.nativeEl.selectionEnd = modelValueLength;
        }
      }
    }

    @Watch('dayModel')
    @Watch('monthModel')
    @Watch('yearModel')
    sep_watcher() {
      const d = new Date(+this.yearModel, (+this.monthModel-1), +this.dayModel);
      
      console.log(d)
      if (d instanceof Date && !isNaN(d.getTime())) {
        this.emitModelValue(d)
      }
    }

    @Watch('modelValue', { deep: true })
    m_watcher(val: Date, val_prev: any) {
      console.log('new date model v: ')
      console.log(val)
      if (val && (!val_prev || val != val_prev)) {
        this.dayModel = ''+val.getDate()
        this.monthModel = ''+val.getMonth()
        this.yearModel = ''+val.getFullYear()
      }
    }
}
</script>

<style lang="scss">
.q-btn__content > span {
  text-align: left !important;
}

/* edit fields */

.thin-input-noborder, .thin-input-noborder > * {
  height: 26px !important;
  min-height: 26px !important;

  .q-field__control {
    border-radius: 4px !important;
    height: 26px !important;
    min-height: 26px !important;
    font-size: 12.5px;
  }

  .q-field__control:before {
    border: 0 !important;
  }

  .q-field__control:after {
    border: 0 !important;
  }

  .q-field__native {
    min-height: 26px !important;
  }

  .q-field__marginal {
    height: 26px !important;
  }

  .q-field__bottom {
    font-size: 10px !important;
    padding: 5px 0 0 !important;
  }

  .q-field__native {
    padding: 0 !important;
  }

  .q-field {
    border-radius: 4px !important;
    padding-top: 4px !important;
    padding-bottom: 18px !important;
  }
}

.thin-input-noborder-larger, .thin-input-noborder-larger > * {
  height: 20px !important;
  min-height: 20px !important;

  .q-field__control {
    height: 20px !important;
    min-height: 20px !important;
    font-size: 14px;
  }

  .q-field__control:before {
    border: 0 !important;
  }

  .q-field__control:after {
    border: 0 !important;
  }

  .q-field__native {
    min-height: 20px !important;
  }

  .q-field__marginal {
    height: 20px !important;
  }

  .q-field__bottom {
    font-size: 10px !important;
    padding: 5px 0 0 !important;
  }

  .q-field__native {
    padding: 0 !important;
  }

  .q-field {
    border-radius: 4px !important;
    padding-top: 4px !important;
    padding-bottom: 18px !important;
  }
}

.err-mode-field {
  .q-field__native {
    color: red !important;
  }
}

</style>
